
import {Component, Prop, Vue} from "vue-property-decorator";
import {alertModule, authModule} from "@/store";

@Component
export default class ExternalRedirectView extends Vue {
  @Prop() readonly refreshToken!: string;
  @Prop() readonly url!: string;

  private loginSuccess = false;
  private loading = true;

  private get existRoute() {
    return this.$router.getMatchedComponents(this.url).length === 1;
  }

  private get paramsValid() {
    return this.refreshToken != null && this.url != null;
  }

  async mounted() {
    await alertModule.dismissAll();

    if (!this.paramsValid || !this.existRoute) {
      this.loading = false;
      return;
    }

    this.loginSuccess = await authModule.loginAfterExternalRedirect(this.refreshToken);
    this.loading = false;

    if (this.loginSuccess) {
      await this.$router.push(this.url);
    }
  }
}
